import { NgModule, Injector } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { RequiredDocumentsService } from '../../../common/js/services/RequiredDocumentService';

// components
import { AppComponent } from './components/app.component';

// modules
import { ApplicationFormModule } from '../../../coverpath-common/angular/components/application-form/application-form.module';
import { HomeModule } from './components/home/home.module';
import { EolHomeModule } from './components/eol-home/eol-home.module'; 
import { MarginalsModule } from './components/marginals/marginals.module';
import { ModalModule } from '../../../coverpath-common/angular/components/modals/modal.module';
import { BaseFormModule } from '../../../coverpath-common/angular/components/form/base-form.module';
import { AppRoutingModule } from './app.router.module';
import { QuoteModule } from './components/home/quote/quote.module';
import { LoginModule } from './components/login/login.module';
import { FaqModule } from './components/faq/faq.module';
import { AccountCenterModule } from './components/account-center/account-center.module';
import { AccountSettingsModule } from '../../../coverpath-common/angular/components/account-settings/account-settings.module';
import { InsuredAcknowledgementModule } from '../../../coverpath-common/angular/components/acknowledgement/acknowledgement.module';
import { CpDialogModule } from '../../../coverpath-common/components/dialog/dialog.module';

// services
import { AuthGuard } from './services/navguard/auth.navguard';
import { ApplicationFormGuard } from './services/navguard/application-form.navguard';
import { IndividualApplicationAccessGuard } from '../../../coverpath-common/angular/navguards/IndividualApplicationAccessGuard';
import { MMDirectLogoutModule } from './components/logout/mmdirect-logout.module';
import { AMCAuthenticationResolver } from '../../../coverpath-common/angular/resolvers/authentication/AMCAuthenticationResolver';
import { Auth0Guard } from '../../../coverpath-common/angular/navguards/Auth0Guard';
import { ToasterModule } from '../../../coverpath-common/angular/components/overlays/toaster/toaster.module';
import { SharedModule } from '../../../coverpath-common/angular/components/shared/shared.module';

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        FormsModule,
        HttpClientModule,
        RouterModule,
        AppRoutingModule,
        ApplicationFormModule.forRoot(),
        BaseFormModule,
        HomeModule,
        EolHomeModule,
        LoginModule,
        FaqModule,
        AccountCenterModule,
        AccountSettingsModule,
        InsuredAcknowledgementModule,
        MarginalsModule,
        ModalModule,
        QuoteModule,
        MMDirectLogoutModule,
        ToasterModule,
        CpDialogModule,
        SharedModule
    ],
    providers: [
        AuthGuard,
        Auth0Guard,
        IndividualApplicationAccessGuard,
        ApplicationFormGuard,
        RequiredDocumentsService,
        AMCAuthenticationResolver
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule {
    /**
     * Allows for retrieving singletons using `AppModule.injector.get(MyService)`
     * (whereas `ReflectiveInjector.resolveAndCreate(MyService)` would create a
     * new instance of the service).
     */
    static injector: Injector;
    constructor(injector: Injector) {
        AppModule.injector = injector;
    }
}
